module.exports = __webpack_public_path__ + "static/media/lb-undo.4b352f57.svg";